import email from "../../assets/email.svg";
import phone from "../../assets/phone.svg";
import facebook from "../../assets/facebook.svg";
import instagram from "../../assets/instagram.svg";
import twitter from "../../assets/twitter.svg";
import youtube from "../../assets/youtube.svg";
import logo from "../../assets/logo.svg";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./style.css";

const Navbar = () => {
	const [isActive, setIsActive] = useState("Home");
	const [isOpen, setIsOpen] = useState(false);

	const toggleNavbar = () => setIsOpen(!isOpen);
	const closeNavbar = () => setIsOpen(false);

	return (
		<nav>
			<div className="navbar">
				<div className="nav-logo">
					<img src={logo} alt="logo" />
				</div>

				<div className="navbar-expand-lg">
					<div className="container-fluid">
						<button
							className={`navbar-toggler hamburger ${isOpen ? "open" : ""}`}
							type="button"
							onClick={toggleNavbar}
							data-bs-toggle="collapse"
							data-bs-target="#navbarNavAltMarkup"
							aria-controls="navbarNavAltMarkup"
							aria-expanded="false"
							aria-label="Toggle navigation">
							<span></span>
							<span></span>
							<span></span>
						</button>
						<div
							className={`collapse navbar-collapse ${isOpen ? "show" : ""}`}
							id="navbarNavAltMarkup">
							<div className="navbar-nav">
								<Link
									to="/"
									onClick={() => {
										setIsActive("Home");
										closeNavbar();
									}}
									className={
										isActive === "Home" ? "active nav-link" : "nav-link"
									}
									aria-current="page">
									Home
								</Link>
								<Link
									to="/"
									state={{ scrollTo: "categories" }}
									onClick={() => {
										document.getElementById("categories")?.scrollIntoView({
											behavior: "smooth",
										});
										setIsActive("Categories");
										closeNavbar();
									}}
									className={
										isActive === "Categories" ? "active nav-link" : "nav-link"
									}
									aria-current="page">
									Categories
								</Link>
								<Link
									to="/about-us"
									// state={{ scrollTo: "about" }}
									// onClick={() => {
									// 	document.getElementById("about")?.scrollIntoView({
									// 		behavior: "smooth",
									// 	});
									// 	setIsActive("About");
									// 	closeNavbar();
									// }}
									className={
										isActive === "About" ? "active nav-link" : "nav-link"
									}
									aria-current="page">
									About
								</Link>
								<Link
									to="/"
									state={{ scrollTo: "Features" }}
									onClick={() => {
										document.getElementById("Features")?.scrollIntoView({
											behavior: "smooth",
										});
										setIsActive("Features");
										closeNavbar();
									}}
									className={
										isActive === "Features" ? "active nav-link" : "nav-link"
									}
									aria-current="page">
									Features
								</Link>
								<Link
									to="/"
									state={{ scrollTo: "Screenshot" }}
									onClick={() => {
										document.getElementById("Screenshot")?.scrollIntoView({
											behavior: "smooth",
										});
										setIsActive("Screenshot");
										closeNavbar();
									}}
									className={
										isActive === "Screenshot" ? "active nav-link" : "nav-link"
									}
									aria-current="page">
									Screenshot
								</Link>
								<Link
									to="/"
									state={{ scrollTo: "Download" }}
									onClick={() => {
										document.getElementById("Download")?.scrollIntoView({
											behavior: "smooth",
										});
										setIsActive("Download");
										closeNavbar();
									}}
									className="download tablet mobile"
									aria-current="page">
									Download
								</Link>
							</div>
						</div>
					</div>
				</div>

				<Link
					to="/"
					state={{ scrollTo: "Download" }}
					onClick={() => {
						setIsActive("Download");
						closeNavbar();
					}}
					className="download web"
					aria-current="page">
					Download
				</Link>
			</div>
		</nav>
	);
};
export default Navbar;
